export const BUTTON_CONSTANTS = {
    BackBtn: 'backButton',
    SaveBtn: 'saveButton',
    SaveAndContinueBtn: 'saveAndContinueButton',
    NewRecordBtn: 'newRecordBtn',
    NextBtn:'nextButton'
}